import React from 'react';
import styled from 'styled-components';
import Box from '../Box/Box.js';
import sx from '../sx.js';
import { SEGMENTED_CONTROL_CSS_MODULES_FEATURE_FLAG, getSegmentedControlListItemStyles, getSegmentedControlButtonStyles } from './getSegmentedControlStyles.js';
import { defaultSxProp } from '../utils/defaultSxProp.js';
import { isElement } from 'react-is';
import getGlobalFocusStyles from '../internal/utils/getGlobalFocusStyles.js';
import '../FeatureFlags/FeatureFlags.js';
import { useFeatureFlag } from '../FeatureFlags/useFeatureFlag.js';
import '../FeatureFlags/DefaultFeatureFlags.js';
import classes from './SegmentedControl.module.css.js';
import { clsx } from 'clsx';
import { toggleStyledComponent } from '../internal/utils/toggleStyledComponent.js';
import merge from 'deepmerge';

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const SegmentedControlButtonStyled = toggleStyledComponent(SEGMENTED_CONTROL_CSS_MODULES_FEATURE_FLAG, 'button', styled.button.withConfig({
  displayName: "SegmentedControlButton__SegmentedControlButtonStyled",
  componentId: "sc-8lkgxl-0"
})(["", ";", ";"], getGlobalFocusStyles('-1px'), sx));
const SegmentedControlButton = ({
  children,
  leadingIcon: LeadingIcon,
  selected,
  sx: sxProp = defaultSxProp,
  className,
  ...rest
}) => {
  const enabled = useFeatureFlag(SEGMENTED_CONTROL_CSS_MODULES_FEATURE_FLAG);
  const mergedSx = enabled ? sxProp : merge(getSegmentedControlListItemStyles(), sxProp);
  return /*#__PURE__*/React.createElement(Box, {
    as: "li",
    sx: mergedSx,
    className: clsx(enabled && classes.Item),
    "data-selected": selected || undefined
  }, /*#__PURE__*/React.createElement(SegmentedControlButtonStyled, _extends({
    "aria-current": selected,
    sx: enabled ? undefined : getSegmentedControlButtonStyles({
      selected,
      children
    }),
    className: clsx(enabled && classes.Button, className),
    type: "button"
  }, rest), /*#__PURE__*/React.createElement("span", {
    className: clsx(enabled ? classes.Content : 'segmentedControl-content')
  }, LeadingIcon && /*#__PURE__*/React.createElement(Box, {
    mr: 1
  }, isElement(LeadingIcon) ? LeadingIcon : /*#__PURE__*/React.createElement(LeadingIcon, null)), /*#__PURE__*/React.createElement(Box, {
    className: clsx(enabled ? classes.Text : 'segmentedControl-text'),
    "data-text": children
  }, children))));
};
SegmentedControlButton.displayName = "SegmentedControlButton";

export { SegmentedControlButton as default };
